/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerFindOneQueryResponse, UserControllerFindOnePathParams, UserControllerFindOneQueryParams, UserControllerFindOne400, UserControllerFindOne401, UserControllerFindOne403, UserControllerFindOne404 } from "../../models/usersController/UserControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { userControllerFindOne } from "../../clients/usersService/userControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const userControllerFindOneQueryKey = (userId: UserControllerFindOnePathParams["userId"], params: UserControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/users/:userId',
  params: {
    userId: userId
  }
}, ...(params ? [params] : [])] as const;
export type UserControllerFindOneQueryKey = ReturnType<typeof userControllerFindOneQueryKey>;
export function userControllerFindOneQueryOptions(userId: UserControllerFindOnePathParams["userId"], params?: UserControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = userControllerFindOneQueryKey(userId, params);
  return queryOptions<UserControllerFindOneQueryResponse, ResponseErrorConfig<UserControllerFindOne400 | UserControllerFindOne401 | UserControllerFindOne403 | UserControllerFindOne404>, UserControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!userId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return userControllerFindOne(userId, params, config);
    }
  });
}

/**
 * @summary Get a user by id
 * {@link /api/v1/users/:userId}
 */
export function useUserControllerFindOne<TData = UserControllerFindOneQueryResponse, TQueryData = UserControllerFindOneQueryResponse, TQueryKey extends QueryKey = UserControllerFindOneQueryKey>(userId: UserControllerFindOnePathParams["userId"], params?: UserControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<UserControllerFindOneQueryResponse, ResponseErrorConfig<UserControllerFindOne400 | UserControllerFindOne401 | UserControllerFindOne403 | UserControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? userControllerFindOneQueryKey(userId, params);
  const query = useQuery({
    ...userControllerFindOneQueryOptions(userId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<UserControllerFindOne400 | UserControllerFindOne401 | UserControllerFindOne403 | UserControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}